import React from "react";
import "./Works.css";
import Upwork from "../../img/Upwork.png";
import Fiverr from "../../img/fiverr.png";
import Amazon from "../../img/amazon.png";
import Shopify from "../../img/Shopify.png";
import Facebook from "../../img/Facebook.png";
import { motion } from "framer-motion";

const Works = () => {
  return (
    <div className="works">
      <div className="awesome">
        <span>Works for all these </span>
        <span>brands and clients</span>
        <span>
          Lorem ipsum dolor sit amet consectetur adipisicing elit.elit. Aperiam,
          ut.
          <br />
          Lorem ipsum dolor sit amet, consectetur adipisicing
          <br />
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam
          <br />
          Lorem ipsum dolor sit amet consectetur
        </span>
        <button className="button s-button">Download CV</button>

        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      <div className="w-right">
        <motion.div
          initial={{ rotate: 45 }}
          whileInView={{ rotate: 0 }}
          viewport={{ margin: "-40px" }}
          transition={{ duration: 3.5, type: "spring" }}
          className="w-mainCircle"
        >
          <div className="w-seccircle">
            <img src={Upwork} alt="" />
          </div>
          <div className="w-seccircle">
            <img src={Fiverr} alt="" />
          </div>
          <div className="w-seccircle">
            <img src={Amazon} alt="" />
          </div>
          <div className="w-seccircle">
            <img src={Shopify} alt="" />
          </div>
          <div className="w-seccircle">
            <img src={Facebook} alt="" />
          </div>
        </motion.div>
        {/* backgroiund-circle */}
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
      </div>
    </div>
  );
};

export default Works;
